import { render, staticRenderFns } from "./comp-room.vue?vue&type=template&id=238a2005&scoped=true"
import script from "./comp-room.vue?vue&type=script&lang=js"
export * from "./comp-room.vue?vue&type=script&lang=js"
import style0 from "./comp-room.vue?vue&type=style&index=0&id=238a2005&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a2005",
  null
  
)

export default component.exports